import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import {useNavigate } from "react-router-dom";
import './App.css';

export default function Deleteloan() {
  const [ldetail, setLdetail] = useState([]);
  const API_URL = process.env.REACT_APP_WEB_API_KEY;
  const navigate = useNavigate();
  const [account, setAccount] = useState([]);

  useEffect(()=>
{
    fetch(API_URL+"api/Ledger/GetAccounts")
    .then(response => response.json())
    .then(data => {setAccount(data)});
    
},[])
  
  
  function loandetail()
  {
  
     fetch(API_URL + "api/Loan/LoanEdit?id=" + document.getElementById("loanno").value).then(res => res.json())
     .then((data) => { setLdetail(data) });
  }


  function loandetails() 
  {
    if(ldetail.length === 0 )
    {
      errorDialog();
    }
    else
    {
    document.getElementById("cName").value = ldetail[0].CustomerName;
    document.getElementById("doloan").value = ldetail[0].LoanDate.slice(0, 10) ;
    document.getElementById("loantype").value = ldetail[0].TypeOfLoan;
    document.getElementById("duration").value = ldetail[0].Installments;
    document.getElementById("lAmount").value = ldetail[0].LoanAmount;
    document.getElementById("iRate").value = ldetail[0].Interest;
    document.getElementById("clDate").value = ldetail[0].DateOfLoanClosing.slice(0, 10);
    document.getElementById("inttaken").value = ldetail[0].InterestTaken;
    document.getElementById("docfee").value = ldetail[0].DocumentFee;
    document.getElementById("disamt").value = ldetail[0].LoanBalance - ldetail[0].InterestTaken - ldetail[0].DocumentFee;
    }
  }

  function deleteloan()
  {
    
    fetch(API_URL+"api/Loan/DeleteLoan?loanid="+ document.getElementById("loanno").value,{method:"PUT",body:null}).then(response => response.json())
    .then(() =>{});

    fetch(API_URL+"api/Interest/DeleteInterest?loanid="+ document.getElementById("loanno").value,{method:"PUT",body:null}).then(response => response.json())
    .then(() =>{});


    const cashaccount = account.filter((e)=>{if(e.AccountID === 3){return e;}})
    const loanaccount = account.filter((e)=>{if(e.AccountID === 4){return e;}})
    const documentaccount = account.filter((e)=>{if(e.AccountID === 7){return e;}})
    const interestaccount = account.filter((e)=>{if(e.AccountID === 5){return e;}})

    fetch(API_URL+"api/Ledger/DeleteAccountLedgerEntry?id="+ ldetail[0].CommonID,{method:"put",body:null})
    .then(response => response.json())
    .then(() =>{});

    fetch(API_URL+"api/Ledger/DeleteLoanLedgerEntry?id="+ ldetail[0].CommonID,{method:"put",body:null})
    .then(response => response.json())
    .then(() =>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+cashaccount[0].AccountID+"&amount="+(cashaccount[0].CurrentCredit-ldetail[0].LoanAmount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+loanaccount[0].AccountID+"&amount="+(loanaccount[0].CurrentDebit-ldetail[0].LoanAmount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+cashaccount[0].AccountID+"&amount="+(cashaccount[0].CurrentDebit-ldetail[0].InterestTaken-ldetail[0].DocumentFee),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+interestaccount[0].AccountID+"&amount="+ (interestaccount[0].CurrentCredit-ldetail[0].InterestTaken),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});


    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+documentaccount[0].AccountID+"&amount="+ (documentaccount[0].CurrentCredit-ldetail[0].DocumentFee),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    showOKdialog();
  }

function showOKdialog()
{
  const dialog = document.getElementById('myDialog');
  dialog.showModal();
}

function errorDialog()
{
  const dialog = document.getElementById('errorDialog');
  dialog.showModal();
}

function closeerrorDialog()
{
  const dialog = document.getElementById('errorDialog');
  dialog.close();
}
 
  console.log(ldetail);

return (
    <>
    <div style={{ height: "100%", width: "100%" }}>
      <div style={{
        width: "100%", height: "40px", paddingLeft: "10px",
        backgroundColor: "blue", color: "white", textAlign: "left", fontSize: "25px"
      }}>Finance Assistant </div>
      <div style={{
        width: "100%", height: "30px", paddingLeft: "10px",
        backgroundColor: "goldenrod", color: "white", textAlign: "center", fontSize: "20px"
      }}>Delete Loan </div>
      <Navbar />
      <label for="loanno" style={{ marginLeft: "20px" }}>Loan No</label>
      <input id="loanno" style={{ height: "30px", width: "40%", marginLeft: "10px" }} onChange={()=>{loandetail()}} ></input>
      <button type="button" style={{ height: "34px", width: "20%", marginLeft: "22px", marginTop: "10px", backgroundColor: "orange", color: "white", fontSize: "14px", fontWeight: "bolder", borderRadius: "5px" }} onClick={() => { loandetails()}} >Search</button>
      <fieldset style={{ marginBottom: "20%" }}>
        <legend>Loan Info</legend>

        <label for='cName'>Customer</label><br />
        <input type="text" id='cName' className='inputfield'></input> <br /><br />

        <label for='doloan'>Date Of Loan </label><br />
        <input id='doloan' type="date" className='inputfield' /><br /><br />

        <label for="loantype">Type Of Loan</label>
        <label for="duration" style={{ marginLeft: "29%" }}>Duration</label><br />
        <input id="loantype" type='text' value="Daily" style={{ height: "30px", width: "39%" }}></input>
        <input id="duration" value="100" type='text' style={{ height: "30px", width: "41%", marginLeft: "15%" }}></input><br /><br />

        <label for="lAmount">Loan Amount</label>
        <label for='iRate' style={{ marginLeft: "29%" }}>Interest Rate</label><br />
        <input type='text' id='lAmount' style={{ height: "30px", width: "39%" }} ></input>
        <input id='iRate' type='text' style={{ height: "30px", width: "41%", marginLeft: "15%" }}  /> <br /><br />

        <label for="clDate">Closing Date</label><br />
        <input type="date" id="clDate" className='inputfield' ></input><br /><br />

        <label for="inttaken">Interest Taken</label>
        <input type='text' id='inttaken' className='inputfield'></input><br /><br />

        <label for='docfee'>Document Fee</label><br />
        <input id = 'docfee' type = 'text' className='inputfield' ></input><br/><br/>

        <label for='disamt'>Final Amount</label><br />
        <input id='disamt' type='text' className='inputfield'></input>

        <div>
          <button type="button" className="actionbuttons" onClick={()=>{deleteloan()}}>Delete Loan</button>
          <button type="button" className="actionbuttons" style ={{backgroundColor:"red"}} onClick={() => { navigate('/changes') }} >Cancel</button>
        </div>
      </fieldset>
      </div>
      <dialog id="myDialog" className="okdialog"><p>Loan Deleted</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/changes')}}>OK</button>
      </dialog>

      <dialog id="errorDialog" className="okdialog"><p>The Loan is under collection Progress Or Inactive</p>
            <button className="okdialogbutton" onClick={()=>{closeerrorDialog()}}>OK</button>
      </dialog>
    </>
  )
}